import React, { KeyboardEvent, useState } from 'react';
import { AddIcon } from 'cokitchen-icons';
import { Input } from '@cokitchen/cokitchen-components';

const CreateMetadata = ({ onEnter }: { onEnter: (e: any, popular: boolean) => void }) => {
  const [value, setValue] = useState('');
  const [popular, setPopular] = useState(false);

  const handleEnterKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (!(e.target as HTMLInputElement).value) return;
    if (e.key === 'Enter') {
      onEnter(value, popular);
      setValue('');
    }
  };

  return (
    <div className='py-2 px-4 text-xs flex items-center gap-5'>
      <div
        onKeyDown={handleEnterKeyPress}
        className=' w-32 text-[#969A9C] font-medium px-[6px] py-[2px] rounded-[3px] bg-[#E1F3FFCC] flex items-center gap-1'>
        <AddIcon /> <p className=''> Create new</p>
      </div>
      <input
        placeholder='Type something'
        value={value}
        onChange={(e) => setValue?.(e.target.value)}
        className='h-full bg-transparent outline-none placeholder:tracking-[1px] tracking-[1px] text-gray-5  border-none p-1 grow'
        onKeyDown={handleEnterKeyPress}
      />
      <div className='w-full flex gap-2 justify-end mt-1'>
        <p className=' w-fit flex-nowrap text-2xs text-gray-5 px-3 py-1 border bg-white border-[#EFF0F0] bg-white2 rounded-[3px]'>
          Press “enter” to save
        </p>
        <div className='text-xs bg-white flex justify-end gap-2 w-fit items-center rounded-[4px] p-1'>
          <Input
            type='checkbox'
            name='new'
            checked={popular}
            checkColor='gray'
            onChange={() => setPopular(!popular)}
            onKeyDown={handleEnterKeyPress}
            className=''
          />
          <p className='text-[#858585] text-2xs'>Set as popular </p>
        </div>
      </div>
    </div>
  );
};

export default CreateMetadata;
